module.exports = global["BVLazyLoad"] = require("-!/export/apps/mobile/node_modules/babel-loader/lib/index.js??ref--12-0!./index.js");